import React, { Fragment, useState } from 'react';
import { IHeaderFilterButton } from './interfaces';
import { Badge, Box, IconButton, Menu } from '@mui/material';

export const HeaderFilterButton: React.FC<IHeaderFilterButton> = ({
  icon: Icon,
  children,
  active,
}): JSX.Element => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <IconButton size="small" onClick={handleClick}>
        <Badge
          color="info"
          variant="dot"
          overlap="circular"
          invisible={!active}
        >
          <Icon
            fontSize="small"
            sx={{
              ...(active ? { color: '#757575' } : { color: '#b7b7b7' }),
            }}
          />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Box
          sx={{
            padding: '5px 10px',
            minWidth: '100px',
          }}
        >
          {children}
        </Box>
      </Menu>
    </Fragment>
  );
};
